<template>
    <div class="row" v-if="records && records.length > 0">
        <div class="col-lg-12">
            <div class="col-lg-8">
                <small class="font-weight-bold">
                    Showing {{ pagination.from == 0 ? 1 : pagination.from }} - {{ pagination.to }} of
                    {{ pagination.total }} entries
                </small>
            </div>
            <div class="card shadow">

                <div class="table-responsive">
                    <base-table
                        class="table align-items-center table-flush"
                        thead-classes="thead-light"
                        tbody-classes="list"
                        :data="records"
                    >
                        <template slot="columns">
                            <th width="2%">S/N</th>
                            <th width="10%">Folio Number</th>
                            <th width="20%">Name</th>
                            <th width="10%">Contact</th>
                            <th width="5%">&nbsp;</th>
                        </template>

                        <template
                            slot-scope="{row, index}"
                        >
                        <td class="budget">
                            {{ pagination.from+index}}
                        </td>
                        <td>
                            {{ row && row.basic_profile ? row.basic_profile.folio_number : 'N/A'}}
                        </td>
                        <td class="text-capitalize">
                            {{ row && row.basic_profile ? getFullName(row.basic_profile) : 'N/A'}}
                        </td>
                        <td>
                            {{ row.email }}
                        </td>
                        <td>
                            <base-button
                                type="success" size="sm"
                                @click="updateSignup(row.id, 'approved')"
                                :disabled="(privileges && privileges.update == 'no') || ! privileges"
                            >
                                <i class="fa fa-check"></i> Approve
                            </base-button>
                            <base-button
                                type="danger" size="sm"
                                @click="updateSignup(row.id, 'rejected')"
                                :disabled="(privileges && privileges.delete == 'no') || ! privileges"
                            >
                                <i class="fa fa-ban"></i> Reject
                            </base-button>
                        </td>

                        </template>

                    </base-table>
                </div>

                <div
                    class="card-footer d-flex justify-content-end bg-transparent"
                    v-if="hasPagination"
                     @click="paginate"
                >
                    <base-pagination
                        :total="pagination.total"
                        align="center"
                        v-model="pagination.number"
                        :perPage="pagination.perPage"

                    >
                    </base-pagination>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'NewSignupData',
        props: ["records", "pagination", "hasPagination", "paginate", "privileges", "getFullName",
            "loadPendingSignups", "paginatedItems", "updateSignup"]
    }
</script>